<template>
  <div class="container mt-3">
    <h2>Groups</h2>
    <div class="alert alert-danger" style="text-align: center">
      <h6 style="margin-bottom: 0;">
        !!!Please create a
        <router-link to="/backups" 
                     class="alert-link">snapshot</router-link>BEFORE performing any changes to the database!!!
      </h6>
    </div>
    <div
      class="col-xs-12 col-sm-8 col-md-6 offset-sm-3 offset-md-3 text-center">
      <p v-if="errorMessage" class="mb-3">{{ errorMessage }}</p>
    </div>
    <div
      class="col-xs-12 col-sm-8 col-md-6 offset-sm-3 offset-md-3 text-center">
      <form @submit.prevent="addGroup()">
        <div class="row">
          <div class="col-md-8">
            <input
              id="name"
              v-model="name"
              type="text"
              name="name"
              required
              class="form-control form-control-sm"
              placeholder="Group Name">
          </div>
          <div class="col-md-4">
            <button
              type="submit"
              class="btn btn-sm btn-primary submit-btn">
              Submit
            </button>
          </div>
        </div>
      </form>
      <div class="row bg-light">
        <div class="col-md-8 text-left text-bold p-2">Name</div>
        <div class="col-md-4"/>
      </div>
      <div v-for="group in groups" 
           :key="group.id" 
           class="row">
        <div class="col-md-8 text-left">{{ group.name }}</div>
        <div class="col-md-4">
          <a class="btn" @click.stop="editGroup(group)">Edit</a>
          <a class="btn" @click.stop="deleteGroup(group)">Delete</a>
        </div>
      </div>
    </div>
    <modal-confirm
      v-if="showModal"
      :msg="deleteMessage"
      :action="confirmAction"
      :action-name="confirmActionName"
      @close="showModal = false"/>
  </div>
</template>

<script>
import 'firebase/firestore';
import ModalConfirm from '../components/ModalConfirm.vue';
import EventBus from '../services/eventBus.js';
import {
	labelsCollection,
	groupsCollection,
	translationsCollection,
} from '../services/firebaseConfig';

export default {
	name: 'ListGroups',
	components: {
		ModalConfirm,
		EventBus,
	},
	data() {
		return {
			name: '',
			id: '',
			groups: [],
			errorMessage: '',
			deleteMessage: '',
			confirmAction: 'confirmDelete',
			confirmActionName: 'Delete',
			groupToBeDeleted: {
				name: '',
			},
			showModal: false,
		};
	},
	created() {
		// firebase utils
		groupsCollection.get().then((querySnapShot) => {
			querySnapShot.forEach((doc) => {
				const data = {
					id: doc.id,
					name: doc.data().name,
				};
				this.groups.push(data);
			});
		});
	},
	mounted() {
		EventBus.$on('confirmDelete', () => {
			this.confirmDelete();
		});
	},
	beforeDestroy() {
		EventBus.$off('confirmDelete');
	},
	methods: {
		addGroup: function () {
			// firebase utils
			if (this.id === '') {
				groupsCollection
					.add({
						name: this.name,
					})
					.then((docRef) => {
						const data = {
							id: docRef.id,
							name: this.name,
						};
						this.groups.push(data);
						this.reset();
					})
					.catch((error) => {
						this.errorMessage = error;
					});
			} else {
				const docRef = groupsCollection.doc(this.id);
				docRef
					.update({
						name: this.name,
					})
					.then(() => {
						for (var i in this.groups) {
							if (this.groups[i].id === this.id) {
								const data = {
									id: docRef.id,
									name: this.name,
								};
								this.groups[i] = data;
								this.reset();
								break;
							}
						}
					})
					.catch((error) => {
						this.errorMessage = error;
					});
			}
		},
		editGroup(obj) {
			this.name = obj.name;
			this.id = obj.id;
		},
		deleteGroup(group) {
			this.deleteMessage = 'Are you sure want to delete ' + group.name;
			this.groupToBeDeleted = group;
			this.showModal = true;
		},
		confirmDelete() {
			groupsCollection
				.doc(this.groupToBeDeleted.id)
				.delete()
				.then(() => {
					this.groups = this.groups.filter((item) => {
						return item.id !== this.groupToBeDeleted.id;
					});
					// delete translations
					var docRef = groupsCollection.doc(this.groupToBeDeleted.id);
					var lblRef = labelsCollection.where('group', '==', docRef);

					lblRef.get().then((snapshot) => {
						snapshot.docs.forEach((doc) => {
							doc.ref.delete().then(() => {
								let tranRef = translationsCollection.where(
									'label',
									'==',
									doc.ref
								);

								tranRef.get().then((tranSnapshot) => {
									tranSnapshot.docs.forEach((doc) => {
										doc.ref.delete();
									});
								});
							});
						});
					});
				})
				.catch((error) => {
					this.errorMessage = error;
				});
			this.showModal = false;
		},
		reset() {
			this.id = '';
			this.name = '';
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/ListGroups.vue